export default __webpack_public_path__ + "static/media/tpp-vet-care-plan.2e44a21a.svg";